import React, { useEffect, useMemo } from 'react';
import Modal from '@mui/material/Modal';
import {
  Box,
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import DataTable from '../../Common/DataTable';
import { Cancel } from '../../media/images/Cancel';
import { Datatablestyle } from './utils/Constant';
import { FOUserBidReportTable } from './utils/TypeDashboard';
import { getBidReportList } from './redux/dashboardSlice';
import { RootState } from '../../redux/rootState';
import { PrintIcon } from '../../assets/TableIcons';
import { showErrorToaster } from '../../Common/ComponentToast/ComponentSuccessToasts';
import { exportToExcelData } from '../../Common/PageHeader/helper';
import { formatPriceWithCommas } from '../../utils/CommonFunctions';

interface IBidReportDetailsModal {
  open: string;
  handleClose: () => void;
}

export default function BidReportDetailsModal({
  open, handleClose,
}: IBidReportDetailsModal) {
  const dispatch = useDispatch();

  useEffect(() => {
    if (open?.length > 0) {
      const pay = {
        UserId: open,
        // PageSize: 20,
        // PageNumber: 1,
      };
      dispatch(getBidReportList(pay));
    }
  }, [open]);

  const { bidReportList, foUsersList } = useSelector((state:RootState) => state.dashboardReducer);

  const selectedUser = useMemo(() => {
    const selectedRecord = foUsersList?.find((item) => item?.UserId === open);
    if (selectedRecord) {
      return selectedRecord?.FOUserName;
    } return '';
  }, [open, foUsersList]);

  const bidDetails = useMemo(() => bidReportList?.map((item) => ({
    id: item?.JobId,
    jobId: item?.JobId,
    bidIdsToolTip: item?.BidIds,
    client: item?.Client,
    siteName: item?.SiteName,
    siteLocation: item?.SiteLocation,
    siteCity: item?.SiteCity,
    siteState: item?.SiteState,
    totalBidForJob: `$ ${formatPriceWithCommas(String(item?.TotalBidForJob))}`,
  })), [bidReportList]);

  const receivedColumns = [
    { key: 'jobId', label: 'Job #' },
    { key: 'bidIdsToolTip', label: 'Bid #' },
    { key: 'client', label: 'Customer' },
    { key: 'siteName', label: 'Site Name' },
    { key: 'siteLocation', label: 'Site Location' },
    { key: 'siteCity', label: 'Site City' },
    { key: 'siteState', label: 'Site State' },
    { key: 'totalBidForJob', label: 'Total Bid Amount' },
  ];
  const downloadExcel = () => {
    if (bidReportList?.length > 0) {
      const exportedData = bidReportList?.map((items) => ({
        JobId: items?.JobId,
        'Bid Ids': items?.BidIds?.join(', '),
        Customer: items?.Client,
        'Site Name': items?.SiteName,
        'Site Location': items?.SiteLocation,
        'Site City': items?.SiteCity,
        'Site State': items?.SiteState,
        'Total Bid Amount ($)': items?.TotalBidForJob,
      }));
      exportToExcelData(
        {
          data: exportedData?.length > 0 ? exportedData : [],
          removeSn: true,
        },
        `Bid Report-(${selectedUser})`,
      );
    } else {
      showErrorToaster('No records to export');
    }
  };

  return (
    <Modal
      open={open?.length > 0}
      onClose={() => {}}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={Datatablestyle}>
        <div className="customerInfo_container flex-row">
          <div className="customerInfo">
            Bid Report for
            {' '}
            {selectedUser}
          </div>
          <div className="cancel-icon" style={{ cursor: 'pointer' }} onClick={() => handleClose()}>
            <Cancel />
          </div>

        </div>
        <div className="customModalBtnContainer">
          <div />
          <div className="pointCursor" onClick={downloadExcel}>
            <PrintIcon />
          </div>
        </div>
        <DataTable<FOUserBidReportTable>
          data={bidDetails || []}
          columns={receivedColumns}
          handleData={() => {}}
          totalRecords={10}
        />
      </Box>
    </Modal>
  );
}
